import { render } from "./tableData.vue?vue&type=template&id=189bfa02&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"

import "./tableData.vue?vue&type=style&index=0&id=189bfa02&scoped=true&lang=css"
import "./tableData.vue?vue&type=style&index=1&id=189bfa02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189bfa02"]])

export default __exports__